import React, { PropsWithChildren, useEffect, useState } from 'react';
import classnames from 'classnames';
import styles from './styles/Slide.module.scss';

interface IProps {
  className?: string;
  showClassName?: string;
  openAfter?: number;
  closeAfter?: number;
  onClick?(): void;
  open: boolean;
}

const Slide: React.FC<PropsWithChildren<IProps>> = ({
  children,
  className,
  showClassName,
  open,
  openAfter,
  closeAfter,
  onClick,
}) => {
  const [show, setShow] = useState(open);

  // Sync the local `show` state with the `open` prop
  useEffect(() => {
    setShow(open);
  }, [open]);

  // Handle delayed open/close based on `openAfter` and `closeAfter`
  useEffect(() => {
    let openTimeoutId: NodeJS.Timeout | undefined;
    let closeTimeoutId: NodeJS.Timeout | undefined;

    if (openAfter !== undefined) {
      openTimeoutId = setTimeout(() => setShow(true), openAfter);
    }

    if (closeAfter !== undefined) {
      closeTimeoutId = setTimeout(() => setShow(false), closeAfter);
    }

    return () => {
      if (openTimeoutId) {
        clearTimeout(openTimeoutId);
      }
      if (closeTimeoutId) {
        clearTimeout(closeTimeoutId);
      }
    };
  }, [openAfter, closeAfter]);

  return (
    <div
      className={classnames(
        styles.container,
        className,
        { [styles.show]: show },
        { [showClassName]: show && showClassName },
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Slide;
